import { httpGet } from "../../../network/fetch";
import { IProfile, Profile } from "../../../model/profile";

export const GetUserProfileHandler = async () => {
    return new Profile(await httpGet<IProfile>({url: "/profile", versionApi: false}));
};
